import React from 'react';
import Icon from 'components/icon/Icon';
export default class TagFilter extends React.Component {

    // Validate data from props
    static propTypes = {
        filter: React.PropTypes.object.isRequired,
        classModifier: React.PropTypes.string,
        selectedItems: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
        toggleFilters: React.PropTypes.func.isRequired,
        resetFilterGroup: React.PropTypes.func.isRequired,
        toggleFocus: React.PropTypes.func.isRequired,
        isFocused: React.PropTypes.bool
    };

    // @NOTE - also used on multi-checkbox-filter component
    componentDidMount() {
        $('body').click((e) => {
            let clickedOn = $(e.target);
            let rootClass = '.multi-checkbox-filter';
            if (!clickedOn.hasClass(rootClass) && !clickedOn.parents(rootClass).length) {
                this.props.toggleFocus.call(this, null);
            }
        });
    }

    handleTitleClick = () => {
        let tagFilters = $(".tag-filter-panel");
        let svgIcon = $(".tag-filter-dropdown .svg-icon");

        svgIcon.toggleClass("flip");

        if (tagFilters.is(":hidden")) {
            tagFilters.slideDown();
        } else {
            tagFilters.slideUp();
        }
    }

    render() {
        let firstTagItemClass = 'tag-filter-item';
        if (this.props.selectedItems.length === 0) {
            firstTagItemClass += ' active';
        }

        return (
            <div className={`tag-filter ${this.props.classModifier}`}>
                <div className="tag-filter-dropdown" onClick={this.handleTitleClick}>
                    <h5 className="tag-filter-dropdown-text">Select {this.props.filter.label}</h5>
                    <Icon className=".svg-icon" glyph='chevron-down' />
                </div>
                <ul className="tag-filter-panel">
                    <li className={firstTagItemClass} onClick={() => this.props.resetFilterGroup(this.props.filter.code)}>
                        <small>All {this.props.filter.label}</small>
                    </li>
                    {this.props.filter.values.map((value, index) => {
                        return (
                            <li key={index}
                                onClick={() => this.props.toggleFilters(this.props.filter, value)}
                                className={`tag-filter-item ${this.props.selectedItems.includes(value) ? 'active' : ''}`}>
                                <small dangerouslySetInnerHTML={{ __html: value }} />
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/tag-filter/TagFilter.jsx
 **/